<template>
  <v-dialog :value="value" persistent width="800">
    <v-card>
      <v-card-title class="pl-5 pr-2 pt-4 pb-2">
        <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
        <div class="title h6">
          Existing Ads Detected
        </div>
        <v-card-subtitle class="py-2 pl-0 pr-2 ma-0" style="word-break: break-word">
          Do you want to replace the existing ads for the groups below as part of the shuttle?
        </v-card-subtitle>
      </v-card-title>
      <v-divider class="mx-4"/>
      <v-container fluid class="pa-0 mx-0">
        <v-data-table
          class="mx-4"
          :headers="headers"
          :items="ads"
          dense
          :height="tableHeight"
          fixed-header
          :footer-props="{'items-per-page-options': [-1]}"
          :items-per-page="-1">
          <template v-slot:[`item.ad_start_date`]="{ item }">
            <span v-if="item.ad_start_date">
              {{ $dateConfig.formatDate(item.ad_start_date) }}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:[`item.ad_end_date`]="{ item }">
            <span v-if="item.ad_end_date">
              {{ $dateConfig.formatDate(item.ad_end_date) }}</span>
            <span v-else>-</span>
          </template>
        </v-data-table>
        <div class="mt-4 d-flex justify-center">
          <v-btn class="ml-4" text @click="close">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="mb-4 mr-4" outlined @click="confirm(false)">
            No, Keep Existing Ads
          </v-btn>
          <v-btn class="mb-4 mr-4" color="warning" @click="confirm(true)">
            Yes, Replace
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { format } from '@/mixins/format'
export default {
  data() {
    return {
      headerProps: {
        sortable: false,
        class: 'accent white--text'
      },
      baseHeaders: [
        { text: 'Ad Group', value: 'ad_group_name' },
        { text: 'Ad Name', value: 'ad_name' },
        { text: 'Start Date', value: 'ad_start_date' },
        { text: 'End Date', value: 'ad_end_date' },
        { text: 'Status', value: 'status' }
      ]
    }
  },
  name: 'ExistingAdShuttleModal',
  mixins: [format],
  props: {
    value: Boolean,
    selectedAd: Object,
    existingAds: Array,
    adGroups: Array
  },
  computed: {
    headers() {
      return this.baseHeaders.map(header => {
        return { ...this.headerProps, ...header }
      })
    },
    ads() {
      return this.existingAds.map(ad => {
        const group = this.adGroups.find(ag => ag.party_id === ad.ad_party_id)
        return {
          ...ad,
          ad_group_name: group?.party_name || ''
        }
      })
    },
    tableHeight() {
      return this.existingAds?.length >= 12 ? '384px' : undefined
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    },
    confirm (confirmed) {
      this.$emit('confirmAction', confirmed)
    }
  }
}
</script>
<style>
.header {
  color: white;
  background: #385F73;
}
.title {
  width: 73%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>